module.exports = __webpack_public_path__ + "img/risk_img_default@3x.6a8ebc1c.png";